export default __webpack_public_path__ + "static/media/two.82250102.jpeg";